export const tableData = {
  head: ["Large language models (LLMs)/Generative AI", "Predictive ML", "AI Decisioning (Reinforcement learning)"],
  rows: [
    {
      rowHead: "Business impact",
      rowData: [
        "Creates content without driving outcomes",
        "Identifies opportunities without executing",
        "Directly optimizes measurable outcomes",
      ],
    },
    {
      rowHead: "Key marketing use cases",
      rowData: [
        "Content generation and creative tasks",
        "Predictive analysis and segmentation",
        "Campaign optimization and 1:1 personalization",
      ],
    },
    {
      rowHead: "Decision process",
      rowData: [
        "Creates options without making decisions",
        "Predicts outcomes without taking action",
        "Continuously experiments and executes",
      ],
    },
    {
      rowHead: "Governance",
      rowData: [
        "Limited control over generated content",
        "Separate systems for governance",
        "Transparency and control",
      ],
    },
  ],
};
